import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAIMessageStyles = makeStyles({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: tokens.spacingVerticalXS,
  },
  footerContent: {
    display: 'flex',
    columnGap: tokens.spacingHorizontalS,
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    minHeight: tokens.spacingVerticalXXL,
  },
  buttons: {
    display: 'flex',
    position: 'absolute',
    top: 0,
  },
  noBubblesButtons: {
    display: 'flex',
    position: 'relative',
    top: 0,
    left: 0,
  },
  dataDisclaimerContainer: {
    width: 'max-content',
    flexGrow: 1,
  },
  dataDisclaimerButton: {
    paddingLeft: tokens.spacingHorizontalNone,
    paddingTop: tokens.spacingHorizontalNone,
    paddingBottom: tokens.spacingHorizontalNone,
    paddingRight: tokens.spacingHorizontalNone,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralStrokeAccessible,
    '&:hover': {
      color: tokens.colorNeutralStrokeAccessible,
    },
    '&:active': {
      color: `${tokens.colorNeutralStrokeAccessible} !important`,
    },
    '&:focus': {
      color: tokens.colorNeutralStrokeAccessible,
    },
    '& span': {
      marginLeft: tokens.spacingHorizontalNone,
      marginTop: tokens.spacingHorizontalXS,
    },
  },
  infoIcon: {
    color: tokens.colorNeutralStrokeAccessible,
    marginLeft: `${tokens.spacingHorizontalNone} !important`,
  },
  referenceGroup: {
    '& .fai-ReferenceGroup__label': {
      fontSize: tokens.fontSizeBase100,
    },
  },
  reference: {
    cursor: 'pointer',
    columnGap: 'unset',
    gridTemplateColumns: '0px 0px 1fr min-content',
    '& .fai-Reference__label': {
      wordBreak: 'break-all',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      ...shorthands.overflow('hidden'),
    },
  },
  messageContent: {
    '& code': {
      color: tokens.colorPaletteBlueBorderActive,
      backgroundColor: tokens.colorNeutralBackground3,
    },
    whiteSpace: 'pre-wrap',
    '& p': {
      marginTop: 0,
      marginBottom: tokens.spacingHorizontalM,
      '&:last-child': {
        marginBottom: 0,
      },
      '&:has(+ ul)': {
        marginBottom: 0,
      },
    },
    '& ul': {
      marginTop: 0,
      marginBottom: tokens.spacingHorizontalM,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  noBubbleAIMessage: {
    backgroundColor: 'unset',
    boxShadow: 'unset !important',
    outline: 'unset',
    paddingLeft: 0,
  },
  noBubbleHeader: {
    color: tokens.colorNeutralForeground3,
    display: 'flex',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalS,
  },
  noBubbleFooter: {
    justifyContent: 'flex-start',
    display: 'inline-block',
    columnGap: tokens.spacingHorizontalS,
    alignItems: 'center',
    position: 'relative',
  },
  noBubbleFooterButtons: {
    minWidth: '20px',
    marginRight: tokens.spacingHorizontalXS,
    display: 'inline',
  },
  copilotHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    '& .copilot-icon': {
      paddingLeft: 0,
    },
  },
});
